import React, {Component, propTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {isDesktop} from 'src/logic/utils';
import config from '../../../config';
import * as actions from 'src/redux/catalogActions';
import Media from 'react-responsive';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import styles from 'src/components/Catalog/elements/ModificationsTable.scss';
import {Link} from 'react-router';
import _ from 'lodash';
import stylesMobile from 'src/components/Catalog/CatalogMobile.scss';


export class GarageModifications extends Component {
  constructor(props, context) {
    super(props, context);
    props.getModifications(props.params.modelId);
  }
  render() {
    const modificationList = this.props.modificationList;
    const garageLink = config.routes.garage;
    const tableRows = _.map(modificationList, (item, i) => {
      return (
        <Tr>
          <Td column="Модификация">
            <Link
              to={`${garageLink}-set/${item.modificationId}`}
              key={`component{i}`}
              className="link">
              {item.modificationName}
            </Link>
          </Td>
          <Td column="Кузов">
            Седан
          </Td>
          <Td column="Модель двигателя">
            {item.engineModel}
          </Td>
          <Td column="Объем двигателя, л.">
            {item.engineVolume}
          </Td>
          <Td column="Мощность, л.с.">
            {item.enginePower}
          </Td>
          <Td column="Год выпуска">
            {item.modificationYearStart + ' - ' + (item.modificationYearEnd ? item.modificationYearEnd : 'наст. время')}
          </Td>
        </Tr>
      );
    });

    const tableRowsMobile = _.map(modificationList, (item, i) => {
      return (
        <div className={stylesMobile.drop_down_category}>
          <Link
            to={`${garageLink}-set/${item.modificationId}`}
            key={`component{i}`}
          >
            <Table className={styles.table}>
              <Tr>
                <Td column="Модификация">
                  {item.modificationName}
                </Td>
                <Td column="Кузов">
                  'Купэ'
                </Td>
                <Td column="Модель двигателя">
                  {item.engineModel}
                </Td>
                <Td column="Объем двигателя, л.">
                  {item.engineVolume}
                </Td>
                <Td column="Мощность, л.с.">
                  {item.enginePower}
                </Td>
                <Td column="Год выпуска">
                  {item.releaseYear + ' - '}{item.endReleaseYear ? item.endReleaseYear : 'наст. время'}
                </Td>
              </Tr>
            </Table>
          </Link>
        </div>
      )
    });

    return (
      <div>
        <div className={styles.back_link}>
          <i className={styles.leftArrow}>&larr; </i>
          <button className="btn btn-link" onClick={() => window.history.back()}>Вернуться назад</button>
        </div>
        <Media query="(min-width: 1025px)">
          <Table className={styles.table}>
            {tableRows}
          </Table>
        </Media>
        <Media query="(max-width: 1024px)">
          {tableRowsMobile}
        </Media>
      </div>
    );
  }
}

GarageModifications.propTypes = {
};

export default connect(
  (state) => ({...state.catalogReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(GarageModifications);











/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageModifications.jsx
 **/